import {
  EpostFormFieldsC4EnvelopeOptionValue,
  EpostFormFieldsColorOptionValue,
  EpostFormFieldsPrintSideOptionValue,
  EpostFormFieldsRegisteredLetterOptionValue,
} from './EpostFormFields.constants'
import { EpostFormFieldsRadioLabel } from './EpostFormFieldsRadioLabel'

import FilesIcon from '../../../icons/copy-1.svg'
import ColorIcon from '../../../icons/epostIcons/color.svg'
import BlackAndWhiteIcon from '../../../icons/epostIcons/color-black-and-white.svg'
import FileIcon from '../../../icons/file.svg'

export function getEpostFormFieldsColorSchemeOptions() {
  return [
    {
      id: EpostFormFieldsColorOptionValue.BlackAndWhite,
      label: (
        <EpostFormFieldsRadioLabel
          Icon={BlackAndWhiteIcon}
          text='Epost.ColorSchemeBlackAndWhiteValueOptionKey'
        />
      ),
    },
    {
      id: EpostFormFieldsColorOptionValue.Color,
      label: (
        <EpostFormFieldsRadioLabel
          Icon={ColorIcon}
          text='Epost.ColorSchemeValueOptionKey'
        />
      ),
    },
  ]
}

export function getEpostFormFieldsPrintSideOptions() {
  return [
    {
      id: EpostFormFieldsPrintSideOptionValue.Single,
      label: (
        <EpostFormFieldsRadioLabel
          Icon={FileIcon}
          text='Epost.PrintSideSingleValueOptionKey'
        />
      ),
    },
    {
      id: EpostFormFieldsPrintSideOptionValue.Double,
      label: (
        <EpostFormFieldsRadioLabel
          Icon={FilesIcon}
          text='Epost.PrintSideDoubleValueOptionKey'
        />
      ),
    },
  ]
}

export function getEpostFormFieldsC4EnvelopeOptions(t) {
  return [
    {
      label: t('Epost.C4EnvelopeNoValueOptionKey'),
      value: EpostFormFieldsC4EnvelopeOptionValue.No,
    },
    {
      label: t('Epost.C4EnvelopeYesValueOptionKey'),
      value: EpostFormFieldsC4EnvelopeOptionValue.Yes,
    },
  ]
}

export function getEpostFormFieldsRegisteredLetterOptions(t) {
  return [
    {
      label: t('Epost.RegisteredLetterNoValueOptionKey'),
      value: EpostFormFieldsRegisteredLetterOptionValue.No,
    },
    {
      label: t('Epost.RegisteredLetterStandartValueOptionKey'),
      value: EpostFormFieldsRegisteredLetterOptionValue.RegMail,
    },
    {
      label: t('Epost.RegisteredLetterWithReceiptValueOptionKey'),
      value: EpostFormFieldsRegisteredLetterOptionValue.RegMailDrop,
    },
    {
      label: t('Epost.RegisteredLetterInternationalValueOptionKey'),
      value: EpostFormFieldsRegisteredLetterOptionValue.RegMailInternational,
    },
  ]
}

export function isEpostFormFieldsRegisteredLetterInternationalOption(option) {
  return (
    option?.value ===
    EpostFormFieldsRegisteredLetterOptionValue.RegMailInternational
  )
}

// api return true/false value (duplex property)
export function trasformEpostFormFieldsApiPrinterSideToOptionValue(value) {
  return value
    ? EpostFormFieldsPrintSideOptionValue.Double
    : EpostFormFieldsPrintSideOptionValue.Single
}

// api return true/false value (color property)
export function trasformEpostFormFieldsApiColorSchemeToOptionValue(value) {
  return value
    ? EpostFormFieldsColorOptionValue.Color
    : EpostFormFieldsColorOptionValue.BlackAndWhite
}

// api takes true/false value (duplex property)
export function trasformEpostFormFieldsPrinterSideOptionValueToApiValue(value) {
  return value === EpostFormFieldsPrintSideOptionValue.Double
}

// api takes true/false value (color property)
export function trasformEpostFormFieldsApiColorSchemeOptionValueToApiValue(
  value
) {
  return value === EpostFormFieldsColorOptionValue.Color
}
